<template>
    <div>
        <div class="prepare-center margin-top">
            <!--备课中心-->
            <div>
                <div class="content-container  delFloat">
                    <!--左侧栏-->
                    <div class=" topHeader commonBackground">
                        <div class="border-bottom">
                            <el-button type="text" class="margin-right">
                                我的收藏
                            </el-button>
                            <el-button type="text">
                                下载记录
                            </el-button>
                        </div>
                        <div >
                            <span class="font-weight-bold margin-right margin-top display-b-i">学科：</span>
                            <span class="type margin-right margin-top"
                                  @click="selectSubject(item.subjectId,item.subjectName)"
                                  :class="selectedSubjectId===item.subjectId?'select':''"
                                  v-for="(item,index) in getSubjectlist"
                                  :key="index" :type="selectedSubjectId===item.subjectId?'primary':''">
                                {{item.subjectName}}
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold margin-right margin-top display-b-i">版本：</span>
                            <span class="type margin-right margin-top"
                                  @click="selectVersion(item.versionId)"
                                  v-for="(item,index) in courseWareVersionModelList"
                                  :class="selectVersionId===item.versionId?'select':''"
                                  :key="index" :type="selectVersionId===item.versionId?'primary':''">
                                {{item.versionName}}
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold margin-right margin-top display-b-i">教材：</span>
                            <span class="type margin-right margin-top"
                                  v-for="(item,index) in getModelList"
                                  :key="index" @click="selectModel(item.moduleId)"
                                  :class="selectModelId===item.moduleId?'select':''">
                                {{item.moduleName}}
                            </span>
                        </div>
                        <div class="delFloat border-top titlef margin-top">
                            <div class="float-left titleD">
                              <div>
                                  一课一网视频
                              </div>
                              <div class="titleDSon">

                              </div>
                            </div>
                        </div>
                        <div></div>
                    </div>

                    <div class="test-show padding-b margin-top commonBackground" style="margin-bottom:80px;">
                        <!--右下栏-->
                        <div class="question-list">
                            <!--内容开始-->
                            <div class="chapter-list">
                                <ul class="chapter-list-wrap" v-loading="loading">
                                    <li v-show="getUnitAndChapterList.length>0">
                                        <div v-for="(itemF,index) in getUnitAndChapterList" :key="index" class="level-1">
                                            <p class="title">
                                                <img src="../../assets/img/lesnPrponCenter/icon_箭头@2x.png" height="16"
                                                     width="16"/>
                                                <span class="margin-left">{{itemF.name}}</span>
                                            </p>
                                            <div class="level-2">
                                                <ul class="chapter-list-child-wrap">
                                                    <li v-for="(itemS,indexS) in itemF.children" :key="indexS"
                                                        :class="getSelectChapterId===itemS.id?'active':''"
                                                        class="chapterSelect text-ellipsis" @click="getInto(itemS,itemF.name)">
                                                        <el-tooltip class="item" effect="dark" v-if="String(itemS.name).length>26" :content="itemS.name" placement="top">
                                                            <span class="child-title" style="width: 100%;">{{itemS.name}}</span>
                                                        </el-tooltip>
                                                        <span v-else>{{itemS.name}}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <div v-show="getUnitAndChapterList.length<1&&!loading" class="margin-top">
                                        <empty content="暂未查出章节"></empty>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <common-target-router @clearHref="clearHref" :getLocation="getLocation"></common-target-router>
    </div>
</template>

<script>
    import {modelSearchZj, preparSubject, preparVersionModel} from "../../config";
    export default {
        name: "prepareCourses",
        data() {
            return {
                //获取所选的学科
                getSubjectName:'',
                loading:true,
                getSubjectlist:[],
                //获取所选中的subjectId
                selectedSubjectId:0,
                //课件版本模块
                courseWareVersionModelList:[],
                //获取已选择的版本id
                selectVersionId:0,
                //查出模块list
                getModelList:[],
                selectModelId:0,
                //获取单元及单元下的内容
                getUnitAndChapterList:[],
                //控制路由跳转
                getLocation:'',
                //获取所选中的章节id
                getSelectChapterId:'',
                //控制路由_blank是否显示触发
                blankActive:false
            }
        },
        mounted(){
          this.searchSubjectList();
        },
        methods: {
            clearHref(){
              this.getLocation='';
            },
            /*选择专辑触发进入视频播放页面*/
            getInto(val,unitName){
                this.blankActive=true;
                setTimeout(()=>{
                    this.getSelectChapterId=val.id;
                    const {href} = this.$router.resolve(
                        {path:'/teacher/prepareCourses_son',
                            query:{chapterId:val.id,chapterUnitName:unitName,
                                chapterName:val.name,selectModelId:this.selectModelId}}
                    );
                    this.getLocation=href;
                    this.blankActive=false;
                })
            },
            //选择科目
            selectSubject(val,subjectName){
                this.getSubjectName=subjectName;
                this.selectedSubjectId=val;
                this.accordingSLookCourseWare();
            },
            //触发选择版本
            selectVersion(val){
                this.selectVersionId=val;
                this.accordingVLookModel();
            },
            //触发选择模块
            selectModel(val){
                this.selectModelId=val;
                this.accordingModelLookChapter();
            },
            //查出学科
            async searchSubjectList(){
                let result=await preparSubject();
                if(result.status){
                    this.getSubjectlist=result.data;
                    //默认查出第一项学科下的版本内容
                    this.selectedSubjectId=this.getSubjectlist[0].subjectId;
                    this.getSubjectName=this.getSubjectlist[0].subjectName;
                    this.accordingSLookCourseWare();
                }else{

                }
            },
            //根据科目查出课件版本模块
            async accordingSLookCourseWare(){
                let result=await preparVersionModel(this.selectedSubjectId);
                if(result.status){
                    this.courseWareVersionModelList=result.data;
                    this.selectVersionId=result.data[0].versionId;
                    this.accordingVLookModel();
                }
            },
            //根据所选择的版本id,filter指定这个版本id下的模块
            accordingVLookModel(){
                let zhi=this.courseWareVersionModelList.filter((val)=>{
                    return val.versionId===this.selectVersionId;
                });
                this.getModelList=zhi[0].modules;
                //默认选择当前模块下的第一项
                this.selectModelId=this.getModelList[0].moduleId;
                this.accordingModelLookChapter();
            },
            //根据模块查出章节
            async accordingModelLookChapter(){
                this.getUnitAndChapterList=[];
                this.loading=true;
                let result=await modelSearchZj(this.selectModelId);
                if(result.status){
                    this.loading=false;
                    if(result.data===null){
                        this.getUnitAndChapterList=[];
                    }else{
                        this.getUnitAndChapterList=result.data;
                    }
                }else{
                    this.loading=false;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .prepare-center {
        .active{
            background: #99ceff;
        }
        .topHeader{
           padding: 0 32px 14px
        }
        .content-container {

            padding: 0 20px;
            .type.select{
                background:#F5F6F6;
                color:#2E7CFD;
            }
            .type{
                cursor:pointer;
                border-radius:2px;
                padding:5px 10px;
                display: inline-block;
            }
            .titlef{
                color:#2E7CFD;
                padding:10px 10px;
            }
            .titleDSon{
                height:3px;
                width:36px;
                border-radius:10px;
                background:#2E7CFD;
                margin:5px 0 0 26px;
            }
            .knowledgeTree {
                width: 280px;
                height: calc(100vh - 134px);
                float: left;
                margin:20px 30px 0 0;
                .el-button {
                    width: 240px;
                    margin: 0 20px;
                }
                .course_select {
                    width: 280px;
                    float: left;
                    cursor: pointer;
                    background-color: #0a93fc;
                    color: #fff;
                    text-align: center;
                    font-size: 16px;
                    z-index: 500;
                    height: 60px;
                    .commonTitle{
                        margin: 10px;font-size: 16px
                    }

                    span {
                        line-height: 60px;
                    }
                }
                .book_select {
                    .collects {
                        ul {
                            margin-top: 66px;
                            li {
                                list-style: none;

                                .el-button {
                                    border: none;
                                    // margin-left: 30px;

                                }
                            }
                        }
                    }

                }
            }

            .test-show {

                .question-list {

                    .flex-box {
                        -webkit-box-pack: justify;
                        -ms-flex-pack: justify;
                        justify-content: space-between;
                        //margin-top: 50px;

                        .el-input {
                            width: 200px;
                            margin-left: 10px;
                        }

                        span {
                            .el-checkbox__label {
                                font-size: 18px !important;
                            }
                        }

                        .question-title {
                            h3 {
                                width: 100%;
                                height: 60px;
                                background: dodgerblue;
                                color: #fff;
                                text-align: center;
                                font-size: 18px;
                                line-height: 60px;
                                border-radius: 10px;
                            }
                        }
                    }

                }


            }
            .chapter-list {
                display: block;
                .chapter-list-wrap {
                    min-height: 300px;
                    position: relative;
                    padding-left: 16px;
                    li{
                        list-style: none;
                    }
                    .level-1>.title {

                        padding: 12px;
                        margin: 0;
                        padding-left: 18px;
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #000000;
                        line-height: 22px;
                    }
                    .level-1>.level-2 ul.chapter-list-child-wrap>li {
                        cursor: pointer;
                        margin: 0;
                        width: 406px;
                        display: inline-block;
                        padding: 0;
                        height: 32px;
                        border-radius: 4px;
                        padding-left: 18px;
                        line-height: 32px;
                        color: #2E7CFD;

                    }
                    .chapterSelect:hover{
                        padding: 5px 10px;
                        background: rgba(32, 156, 255, 0.27);
                        color: dodgerblue;
                    }
                }
            }

        }
    }

</style>
